import {Component, Inject, OnInit, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {PricesService} from '../../services/prices/prices.service';
import {PriceLog} from '../../classes/price-log';
import {CurrencyPipe, DatePipe} from "@angular/common";
import {MatProgressBar} from "@angular/material/progress-bar";

@Component({
    selector: 'app-price-log-dialog',
    templateUrl: './price-log-dialog.component.html',
    styleUrls: ['./price-log-dialog.component.scss'],
    imports: [
        CurrencyPipe,
        DatePipe,
        MatProgressBar,
        MatDialogTitle
    ]
})
export class PriceLogDialogComponent implements OnInit {

    public readonly priceLogs = signal<PriceLog[]>([]);

    constructor(
        private pricesService: PricesService,
        public dialogRef: MatDialogRef<PriceLogDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: object) {
    }

    ngOnInit() {
        this.pricesService
            .getLog(this.data['priceId'], this.data['type'], this.data['inspectionId'])
            .then(log => {
                this.priceLogs.set(log);
            });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

}
